import BusApiCall from "./axios";
import constants from "./constants";

export const getStatesList = async (country, jsonData) => {
  const { data } = await BusApiCall(
    "GET",
    `${constants.busOpenServiceUrl}/country/${country}/states`,
    jsonData ? jsonData : {},
  );
  return data;
};

export const getStateName = async (country, state, jsonData) => {
  const { data } = await BusApiCall(
    "GET",
    `${constants.busOpenServiceUrl}/country/${country}/states`,
    jsonData ? jsonData : {},
  );
  if (data) {
    var index = data.findIndex((a) => a.id === state);
    if (index > -1) {
      return data[index].name;
    } else {
      return state;
    }
  } else {
    return state;
  }
};
